import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, ArkUnitOfWork } from 'app/core/core.module';
import { AuctionItem } from 'app/core/model/auction-item';
import { AuctionPurchase } from 'app/core/model/entity-model';
import { Person } from 'app/core/model/person';
import _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { default as validationEngine } from 'devextreme/ui/validation_engine';

@Component({
    selector: 'app-auction-purchase-dialog',
    templateUrl: './auction-purchase-dialog.component.html',
    styleUrls: ['./auction-purchase-dialog.component.scss'],
})
export class AuctionPurchaseDialogComponent implements OnInit {
    private appInfo = inject(AppInformationService);

    result: Subject<any> = new Subject<any>();
    people: Person[];
    auctionPaddleInfos: any[];
    purchase: AuctionPurchase;
    selectedPaddle: any;
    auctionItems: AuctionItem[];
    selectedItemId: number;
    auctionItem: AuctionItem;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        if (this.selectedItemId) this.auctionItem = (await this.uow.auctionItems.byId(this.selectedItemId)) as AuctionItem;
        console.log(this.selectedItemId);
        console.log(this.auctionItem);
        this.auctionPaddleInfos = this.auctionPaddleInfos.filter((info) => info.paddleUserId !== null);
        if (!this.purchase) {
            this.purchase = this.uow.auctionPurchases.createEntity({
                created: new Date(),
                quantity: 1,
                auctionItemId: this.selectedItemId ? this.selectedItemId : null,
                amount: this.auctionItem && this.auctionItem.linePrice ? this.auctionItem.linePrice : 0,
            }) as AuctionPurchase;
        }
    }

    itemChanged(e) {
        console.log(e);
        if (!!e.value) {
            const item = _.find(this.auctionItems, { id: e.value });
            if (!!item.linePrice) {
                this.purchase.amount = item.linePrice;
            } else {
                this.purchase.amount = 0;
            }
        }
    }

    async save() {
        const result = this.validate();
        if (!result) return;
        await this.uow.commit();
        this.result.next({ success: true, value: this.purchase });
    }
    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
